/**
 * Why `maximumLineLength` rule is disabled for this whole file?
 *
 * Since this file is mostly configuration it is best to disable this rule
 * to favour string readability.
 */
/* jscs:disable maximumLineLength */
define('features/overlayGameLauncher/module',[
    'config/composition',
    './composition'
], function (
    composition,
    dependencies
) {

    var featureName = 'overlayGameLauncher';

    return {
        registerDependencies: function () {
            return composition.registerModuleDependencies(dependencies, featureName);
        },
        registerRoutes: function () {

        }
    };
});

